import axios from "axios";
import {axiosFormDataConfigs, getFormData} from "../../../../../_emywork/helpers/AxiosHelpers";
import {toAbsoluteApiUrl} from "../../../../../_metronic/_helpers";

export const API_URI = toAbsoluteApiUrl("/user_messages");

const normalize = _entity => {
  let entity = {..._entity};
  delete entity.created_at;
  delete entity.updated_at;
  // if(entity.category) entity.category = { id : entity.category.id }
  return entity
}

export const getAll = (metadata) => axios.get(API_URI, { params: { meta: metadata }});
export const getChat = (id, metadata) => axios.get(`${API_URI}/${id}/width_user`, { params: { meta: metadata }});
export const getById = (id, metadata) => axios.get(`${API_URI}/${id}`, { params: { meta: metadata }});
export const deleteEntity = id => axios.delete(`${API_URI}/${id}`);
export const create = entity => axios.post(API_URI, getFormData(normalize(entity)), axiosFormDataConfigs );
export const update = entity => axios.post(`${API_URI}/${entity.id}?_method=PUT`, getFormData(normalize(entity)), axiosFormDataConfigs);
